import styled from "styled-components";

export const ChangeNameWrapper = styled.div`
  button {
    margin-top: 20px;
  }
`;